/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
class t{constructor(t,e,d){this.added=t,this.updated=e,this.removed=d}hasAnyUpdate(){return!!(this.added.length||this.updated.length||this.removed.length)}}export{t as GraphicUpdateMessage};
